export const STORAGE_KEYS = {
  LANGUAGE: 'language',
  ASSET_GROUP: 'assetGroup',
  THEME: 'theme',
  ACTUAL_BLOCK_COLOR: 'actualBlockColor',
  ASSET_LIST_OPEN_ARR: 'assetListOpenArr',
  USER_KEY: 'userKey',
};
